import React from 'react';

// `fit`: each option sized to its own text (with a minimum), instead of
// stretching to fill the container -- what the control bars use (Oct 2026).
const SegmentedControl = ({ options, value, onChange, className = '', fit = false }) => {
  return (
    <div className={`flex bg-slate-100 p-1 rounded-lg border border-slate-200 shadow-inner h-[36px] items-center ${className}`}>
      {options.map((option) => {
        const isActive = value === option.id;
        return (
          <button
            key={option.id}
            onClick={() => onChange(option.id)}
            className={`
              ${fit ? 'min-w-[76px] px-3' : 'flex-1'} h-full rounded-md text-[12px] font-bold transition-all duration-200 whitespace-nowrap
              flex items-center justify-center gap-1.5
              ${isActive 
                ? 'bg-white text-[var(--primary)] shadow-sm' 
                : 'text-slate-500 hover:text-slate-900'
              }
            `}
          >
            {option.icon && <option.icon className="w-3.5 h-3.5" />}
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
